import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {AlertController, Events, NavController} from "ionic-angular";
import {ContentTranslationProvider} from "../content-translation/content-translation";
import {AppSettingsGoalPage} from "../../pages/app-settings-goal/app-settings-goal";

/*
  Generated class for the PopupUpdateGoalProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PopupUpdateGoalProvider {

  navCtrl: NavController;
  showPopupForModule: string;
  constructor(public alertCtrl: AlertController, public events: Events, public contentTranslation: ContentTranslationProvider) {
    this.events.subscribe('app:show-update-goal-popup', (params: {moduleId: string}) => {
      console.log('show update goal', params);
      this.showPopupForModule = params.moduleId;
    })
    this.events.subscribe('app:module-details-opened', (params: {moduleId: string}) => {
      console.log(params.moduleId, this.showPopupForModule)

      if(this.showPopupForModule == params.moduleId) {
        this.showPopupForModule = null;

        const alert = this.alertCtrl.create({
          title: this.contentTranslation.translateContent('Popup window activity update goal title'),
          subTitle: this.contentTranslation.translateContent('Popup window activity update goal content')+"<img src='/assets/imgs/icon-goal-steps.svg' />",
          buttons: [
            {
              text: this.contentTranslation.translateContent('Popup window activity update goal button'),
              handler: () => {
                this.navCtrl.push(AppSettingsGoalPage)
              }

            },
            {
              text: '×',
              cssClass: 'close-button'
            }
          ],
          cssClass: 'ip-alert ip-with-close ip-dynamic-height'
        });
        alert.present();

      }
    })
  }

  setNavController(navCtrl: NavController) {
    this.navCtrl = navCtrl;
  }

}



// WEBPACK FOOTER //
// ./src/providers/popup-update-goal/popup-update-goal.ts